import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import "./css/bootstrap.min.css";
import "./css/color.css";
import "./css/responsive.css";
import "./css/style.css";
import "./css/font-awesome.min.css";
import "./css/animations.css";

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
